<template>
  <div class="contact-support">
    <div class="contact-support-strip">Super Collection</div>
    <div class="contact-support-hero">
      <div class="contact-support-hero-content">
        <div class="contact-support-hero-title">Get in Touch With Us</div>
        <div class="contact-support-hero-subtitle">
          We’re here to help! Fill out the form below and our support team will get back to you
          within 24–48 hours.
        </div>
      </div>
    </div>
    <div class="contact-support-body">
      <el-form
        ref="contactForm"
        :model="form"
        :rules="rules"
        class="contact-support-form"
      >
        <div class="contact-support-row">
          <el-form-item prop="firstName">
            <el-input v-model="form.firstName" placeholder="First Name"></el-input>
          </el-form-item>
          <el-form-item prop="lastName">
            <el-input v-model="form.lastName" placeholder="Last Name"></el-input>
          </el-form-item>
        </div>
        <el-form-item prop="email">
          <el-input v-model="form.email" placeholder="Email Address"></el-input>
        </el-form-item>
        <el-form-item prop="phone">
          <el-input v-model="form.phone" placeholder="Phone Number"></el-input>
        </el-form-item>
        <el-form-item prop="subject">
          <el-input v-model="form.subject" placeholder="Subject"></el-input>
        </el-form-item>
        <el-form-item prop="message">
          <el-input v-model="form.message" type="textarea" :rows="4" placeholder="Message"></el-input>
        </el-form-item>
        <el-button type="primary" class="contact-support-submit" :loading="submitting" @click="submit">
          Send
        </el-button>
      </el-form>
    </div>
  </div>
</template>

<script>
import * as contactMessagesAPI from '@/api/contact-messages'
export default {
  name: 'ContactSupport',
  data() {
    return {
      submitting: false,
      form: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
      },
      rules: {
        email: [
          { required: true, message: 'Email is required', trigger: 'blur' },
          { type: 'email', message: 'Please enter a valid email', trigger: 'blur' }
        ],
        message: [{ required: true, message: 'Message is required', trigger: 'blur' }],
        firstName: [{ max: 100, message: 'Max 100 characters', trigger: 'blur' }],
        lastName: [{ max: 100, message: 'Max 100 characters', trigger: 'blur' }],
        phone: [{ max: 50, message: 'Max 50 characters', trigger: 'blur' }],
        subject: [{ max: 255, message: 'Max 255 characters', trigger: 'blur' }]
      }
    }
  },
  methods: {
    submit() {
      if (this.submitting) {
        return
      }
      this.$refs.contactForm.validate(valid => {
        if (!valid) {
          return
        }
        this.submitting = true
        contactMessagesAPI
          .postContactMessage(this.form)
          .then(res => {
            if (res.status === 200) {
              this.notifySucceed('Message sent successfully')
              this.$refs.contactForm.resetFields()
            } else {
              this.notifyError('Failed to send message', res.msg)
            }
          })
          .catch(err => {
            this.notifyError('Failed to send message', err)
          })
          .finally(() => {
            this.submitting = false
          })
      })
    }
  }
}
</script>

<style scoped>
.contact-support {
  background: #f4f4f4;
  min-height: 100vh;
}
.contact-support-strip {
  height: 36px;
  background-color: #0f0f14;
  color: #ffffff;
  text-align: center;
  line-height: 36px;
  font-size: 12px;
  letter-spacing: 1px;
  text-transform: uppercase;
}
.contact-support-hero {
  height: 200px;
  max-width: 1200px;
  margin: 24px auto 0;
  border-radius: 6px;
  background: url('/img/Untitled-design.webp') center / cover no-repeat;
  display: flex;
  align-items: center;
  color: #ffffff;
}
.contact-support-hero-content {
  width: 100%;
  padding: 0 32px;
}
.contact-support-hero-title {
  font-size: 32px;
  font-weight: 700;
}
.contact-support-hero-subtitle {
  margin-top: 8px;
  font-size: 14px;
  opacity: 0.9;
  max-width: 520px;
}
.contact-support-body {
  width: 1200px;
  margin: 0 auto;
  padding: 32px 24px 80px;
  display: flex;
  justify-content: center;
}
.contact-support-form {
  width: 520px;
  background: #ffffff;
  padding: 24px;
  border-radius: 6px;
  box-shadow: 0 10px 20px rgba(15, 15, 20, 0.06);
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.contact-support-row {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}
.contact-support-submit {
  width: 100%;
  background: #b20710;
  border-color: #b20710;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}
@media (max-width: 1280px) {
  .contact-support-hero {
    max-width: 100%;
    margin-top: 0;
    border-radius: 0;
  }
  .contact-support-body {
    width: 100%;
  }
}
@media (max-width: 720px) {
  .contact-support-form {
    width: 100%;
  }
  .contact-support-row {
    grid-template-columns: 1fr;
  }
}
</style>
